import { Component, Input, OnChanges, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import {
  SeedListResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/seed-list.response';
import { lastFileUrl } from '../last-file-url.util';
import { SeedTiming, monthName } from '../../../@commons/@services/front/seed-timing.util';
import { StorageService } from '../../../@commons/@services/front/storage.service';
import { StockLevel } from '../../../@commons/pipes/StockLevel';
import { ChevronRightIconComponent } from '../../../@icons/chevron-right.component';
import { VwDatePipe } from '../../../@commons/pipes/vw-date.pipe';

@Component({
  selector: 'vw-seed-item',
  imports: [
    TranslatePipe,
    SharedModule,
    StockLevel,
    ChevronRightIconComponent,
    VwDatePipe,
  ],
  templateUrl: './seed-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './seed-item.component.scss'
})
export class SeedItemComponent implements OnChanges {
  @Input() seed: SeedListResponse;
  /** Quand semer (ou planter) cette graine chez soi ; absent tant que le calendrier n'a pas répondu. */
  @Input() timing: SeedTiming | null = null;
  /** Sans action à droite, le chevron dit que la ligne ouvre le détail. */
  @Input() showChevron = true;
  imageUrl: string = '';
  /** Sachet périmé : la date passe en `danger` (« Périmé depuis 01/2027 »). */
  expired = false;
  private readonly storageService = inject(StorageService);

  ngOnChanges() {
    this.imageUrl = lastFileUrl(this.seed?.cultivation, '');
    this.expired = isExpired(this.seed?.expirationDate);
  }

  /** « À semer : mars à avril chez toi », ou « … : mars chez toi » quand la fenêtre tient dans un mois. */
  get timingLabel(): { key: string; params: { start: string; end: string } } | null {
    if (!this.timing) return null;
    const lang = this.storageService.getCurrentLanguage();
    const sameMonth = this.timing.startMonth === this.timing.endMonth;
    return {
      key: `garden.tabs.seeds.seed-item.timing.${this.timing.kind}-${sameMonth ? 'month' : 'range'}`,
      params: { start: monthName(this.timing.startMonth, lang), end: monthName(this.timing.endMonth, lang) },
    };
  }
}

/** Périmé dès le lendemain de la date d'expiration (date seule, sans heure). */
export function isExpired(expirationDate: Date | string | null | undefined, today: Date = new Date()): boolean {
  if (!expirationDate) return false;
  const day = String(expirationDate).slice(0, 10);
  const pad = (n: number) => String(n).padStart(2, '0');
  const todayDay = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
  return day < todayDay;
}
